module.exports = __webpack_public_path__ + "static/media/bg.397faea2.png";